import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertComponent, ButtonComponent, TileComponent } from '@tecalisdev/infinity';
import { ModalContactExpertComponent } from '../modal-contact-expert/modal-contact-expert.component';

@Component({
	selector: 'app-operation-balance-alert',
	imports: [TranslatePipe, TileComponent, ButtonComponent, AlertComponent, ModalContactExpertComponent],
	templateUrl: './operation-balance-alert.component.html',
	styleUrl: './operation-balance-alert.component.scss',
})
export class OperationBalanceAlertComponent {
	@Input() public balanceStatus: 'ok' | 'low' | 'depleted' = 'ok';

	public showModalContactExpert: boolean = false;

	public openContactForm(): void {
		this.showModalContactExpert = true;
	}

	public closeModalContactExpert(): void {
		this.showModalContactExpert = false;
	}
}
